import {
	getLocationsRequest,
	getLocationByIdRequest,
	newLocationRequest,
	updateLocationRequest,
	deleteLocationRequest,
	getExpandLocationRequest,
	getFilteredGlobalAddressesRequest,
	getExpandPointRequest,
	getTerminalsRequest
} from '../requests';

async function fetchLocation({ commit }, payload ) {
	let response = [];
	try {
		response = await getLocationsRequest({ filterString: payload.searchFilter });
		if (!payload.disableGlobalAddress) {
			let addresses = await getFilteredGlobalAddressesRequest({ filterString: payload.searchFilter });
			response = response.concat(addresses.map(x => ({ ...x, type: 'address' })));
		}
		commit('setLocations', response);
	} catch (err) {
		throw new Error('failedToFetch');
	}
	return response;
}

async function fetchFilterlessLocations() {
	let response = [];
	try {
		response = await getLocationsRequest();
	} catch (err) {
		console.log(err);
		throw new Error('failedToFetch');
	}
	return response;
}

async function fetchSingleLocation({}, id ) {
	let response = {};
	try {
		response = await getLocationByIdRequest(id);
	} catch (err) {
		throw new Error('failedToFetch');
	}
	return response;
}

function setLocations({ commit }, locations) {
	commit('setLocations', locations);
}

async function addNewLocation({}, newLocation ) {
	try {
		await newLocationRequest(newLocation);
	} catch (err) {
		throw new Error('failedToSave');
	}
}

async function editLocation({ commit }, location) {
	try {
		let result = await updateLocationRequest(location, location.id);
		commit('mutateLocation', result);
	} catch (err) {
		throw new Error('failedToUpdate');
	}
}

async function deleteLocation({}, locationId) {
	try {
		await deleteLocationRequest(locationId);
	} catch (error) {
		throw new Error('failedToDelete');
	}
}

async function expandLocation({}, { geometry, radius } ) {
	let response = [];
	try {
		response = await getExpandLocationRequest(geometry, radius);
	} catch (err) {
		throw new Error('failedToExpand');
	}
	return response;
}
async function expandLatLong({}, { geometry, radius } ) {
	let response = [];
	try {
		response = await getExpandPointRequest(geometry, radius);
	} catch (err) {
		throw new Error('failedToExpand');
	}
	return response;
}

function setFromDialog({ commit }, value) {
	commit('setFromDialog', value);
}
function setDialog({ commit }, value) {
	commit('setDialog', value);
}

async function getTerminals({ commit }) {
	try {
		let terminals = await getTerminalsRequest();
		commit('setTerminals', terminals);
	} catch (err) {
		throw new Error('failedToFetch');
	}
}

export default {
	fetchLocation,
	fetchFilterlessLocations,
	fetchSingleLocation,
	setLocations,
	addNewLocation,
	editLocation,
	deleteLocation,
	expandLocation,
	expandLatLong,
	setFromDialog,
	setDialog,
	getTerminals
};
